import { createApp } from "vue";
import ToastNotification from "../../presentation/components/ToastNotification.vue";
let toastInstance = null;
export function useToast() {
    const showToast = (message, type = "info", duration = 3000) => {
        if (toastInstance) {
            toastInstance.addToast(message, type, duration);
        }
        else {
            console.warn("Toast component not initialized");
        }
    };
    const showSuccess = (message, duration) => {
        showToast(message, "success", duration);
    };
    const showError = (message, duration) => {
        showToast(message, "error", duration);
    };
    const showWarning = (message, duration) => {
        showToast(message, "warning", duration);
    };
    const showInfo = (message, duration) => {
        showToast(message, "info", duration);
    };
    return {
        showToast,
        showSuccess,
        showError,
        showWarning,
        showInfo,
    };
}
export function installToast(app) {
    const container = document.createElement("div");
    document.body.appendChild(container);
    const toastApp = createApp(ToastNotification);
    const instance = toastApp.mount(container);
    toastInstance = instance;
    // Make it available globally
    app.config.globalProperties.$toast = useToast();
    return instance;
}
